import { BomLine } from '../../api/models/bom-line';
import { Product } from '../../api/models/product';

export class OrderItem {
  line: BomLine;
  data: Product;
  availability: any;

  constructor(line: BomLine, data: Product, availability: any) {
    this.line = line;
    this.data = data;
    this.availability = availability;
  }

  hasAdvisories() {
    return this.data.advisories ? this.data.advisories.length > 0 : false;
  }

  isBackordered() {
    return this.line.quantity > this.availability.qtyAvailable;
  }

  isNonReturnable() {
    return this.data.returnPolicy === '02';
  }

  notFitMinimum() {
    return this.line.quantity < this.data.minimumQuantity;
  }

  isHazmat() {
    return this.data.isHazmatItem;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/order-item.ts